import { useEffect, useState } from 'react';
import { fetchList } from '@/lib/api';
import { PageHero, VideoCard } from '@/components/Cards';
import { VideoModal } from '@/components/VideoModal';
import { useContent } from '@/lib/useContent';

export default function Videos() {
  const content = useContent();
  const [videos, setVideos] = useState([]);
  const [playing, setPlaying] = useState(null);

  useEffect(() => {
    fetchList('/videos').then((d) => setVideos(d)).catch(() => {});
  }, []);

  const [featured, ...rest] = videos;

  return (
    <>
      <PageHero overline={content.videos_overline || 'Video'} title={content.videos_title || 'Watch'} />

      <section data-testid="videos-page" className="mx-auto max-w-[1500px] px-5 py-16 md:px-10 md:py-24">
        {videos.length === 0 ? (
          <p className="meta-label text-brayo-dim">Videos coming soon.</p>
        ) : (
          <div className="grid gap-10 lg:grid-cols-12">
            <div className="lg:col-span-7">
              <VideoCard video={featured} onPlay={setPlaying} large />
            </div>
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:col-span-5 lg:grid-cols-1">
              {rest.map((v) => (
                <VideoCard key={v.id} video={v} onPlay={setPlaying} />
              ))}
            </div>
          </div>
        )}
      </section>

      <VideoModal video={playing} onClose={() => setPlaying(null)} />
    </>
  );
}